import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  makeStyles,
  FormControl,
  TextField,
  Grid,
  Typography,
  Card,
  CardContent,
} from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';

import TagDownshift from '../../../../../../forms/TagDownshift';
import EventDataSelector from '../../../../../../forms/EventDataSelector';

import styles from './styles';

const useStyles = makeStyles(styles);

export const GeneralFormComponent = (props) => {
  const classes = useStyles();
  const {
    eventTemplate,
    tags,
    tagTypes,
    eventData,
    handleNameChange,
    handleChangeTag,
    handleDescriptionChange,
    handleChangeEventData,
    isLoading,
  } = props;

  const [tagInputValue, setTagInputValue] = useState('');
  const [eventDataInputValue, setEventDataInputValue] = useState('');

  const handleChangeTagInput = (inputVal) => {
    setTagInputValue(inputVal || '');
  };

  const handleChangeEventDataInput = (inputVal) => {
    setEventDataInputValue(inputVal || '');
  };

  const label = (
    <Grid item xs={12} md={3} lg={2}>
      <Typography variant="subtitle2">General Workflow Details</Typography>
      <Typography variant="caption" gutterBottom>
        Define a workflow by giving it a name, description, tags, and custom fields.
      </Typography>
    </Grid>
  );

  if (isLoading) {
    return (
      <Grid container spacing={4}>
        {label}
        <Grid item xs={12} md={9} lg={10} container className={classes.section}>
          <Card className={classes.card}>
            <CardContent>
              <Skeleton className={classes.nameField} />
              <Skeleton />
              <Skeleton />
              <Skeleton />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid container spacing={4}>
      {label}
      <Grid item xs={12} md={9} lg={10} container className={classes.section}>
        <Card>
          <CardContent>
            <TextField
              error={!eventTemplate.validation.name.isValid}
              margin="normal"
              fullWidth
              required
              variant="outlined"
              id="name"
              label="Name"
              value={eventTemplate.name}
              autoFocus
              onChange={handleNameChange}
              className={classes.nameField}
              helperText={
                !eventTemplate.validation.name.isValid
                  && eventTemplate.validation.name.message
              }
            />

            <TextField
              error={!eventTemplate.validation.description.isValid}
              margin="normal"
              fullWidth
              variant="outlined"
              id="description"
              label="Description"
              value={eventTemplate.description}
              onChange={handleDescriptionChange}
              multiline
              rows={3}
              helperText={
                !eventTemplate.validation.description.isValid
                && eventTemplate.validation.description.message
              }
            />

            <FormControl
              margin="normal"
              fullWidth
              variant="outlined"
            >
              <TagDownshift
                onInputValueChange={handleChangeTagInput}
                inputValue={tagInputValue}
                availableItems={tags}
                selectedItem={eventTemplate.tags}
                onChange={handleChangeTag}
                onRemoveItem={handleChangeTag}
                itemToString={(tag) => tag.name}
                tagTypes={tagTypes}
                label="Tags"
                isAdmin
                helperText="Select tags to categorize this workflow."
              />
            </FormControl>
            <FormControl
              margin="normal"
              fullWidth
              variant="outlined"
            >
              <EventDataSelector
                onInputValueChange={handleChangeEventDataInput}
                inputValue={eventDataInputValue}
                availableItems={eventData}
                selectedItem={eventTemplate.eventData}
                onChange={handleChangeEventData}
                itemToString={(eventDataItem) => eventDataItem.name}
                eventData={eventData}
                label="Custom Fields"
                helperText="Select the custom fields used in this workflow to capture additional data."
              />
            </FormControl>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

GeneralFormComponent.propTypes = {
  eventTemplate: PropTypes.object,
  tags: PropTypes.array,
  tagTypes: PropTypes.array,
  eventData: PropTypes.array,
  handleNameChange: PropTypes.func,
  handleChangeTag: PropTypes.func,
  handleDescriptionChange: PropTypes.func,
  handleChangeEventData: PropTypes.func,
  isLoading: PropTypes.bool,
};

GeneralFormComponent.defaultProps = {
  eventTemplate: {},
  tags: [],
  tagTypes: [],
  eventData: [],
  handleNameChange: () => {},
  handleChangeTag: () => {},
  handleDescriptionChange: () => {},
  handleChangeEventData: () => {},
  isLoading: true,
};

export default GeneralFormComponent;
